import { render, staticRenderFns } from "./LogTeaser.vue?vue&type=template&id=3bb7d4a1&"
import script from "./LogTeaser.vue?vue&type=script&lang=js&"
export * from "./LogTeaser.vue?vue&type=script&lang=js&"
import style0 from "./LogTeaser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bb7d4a1')) {
      api.createRecord('3bb7d4a1', component.options)
    } else {
      api.reload('3bb7d4a1', component.options)
    }
    module.hot.accept("./LogTeaser.vue?vue&type=template&id=3bb7d4a1&", function () {
      api.rerender('3bb7d4a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/common/element/LogTeaser.vue"
export default component.exports